import React, {Component} from 'react';
import { ActivityIndicator, NoticeBar } from 'antd-mobile';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import '../styles/UserCouponResult.css';
import iconLogo from '../medias/logo.jpg';
import Constants from '../utils/Constants';

const history = require("history").createHashHistory()

class UserCouponResult extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            detail: {},
            deviceTypes: []
        }
    }

    componentDidMount() {
        this.couponCode = CommonUtils.resolveSearchParam(this.props.location, 'couponCode')
        this.loadData()
    }

    loadData = () => {
        this.loadDeviceTypes()
        this.loadDetail()
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadDetail = (callback) => {
        this.setState({
            loading: true
        })
        DataFetcher.userCouponDetail({
            couponCode: this.couponCode
        }, { 
            success: (resp) => {
                this.setState({
                    detail: resp.data
                }, () => {
                    callback&&callback(resp.data)
                })
            },
            completed: () => {
                this.setState({
                    loading: false
                })
            }
        })
    }

    handleBtnBackClick = () => {
        history.replace('/user/coupon_usage')
    }

    handleBtnRefreshClick = () => {
        this.loadDetail()
    }

    generateResultItemForSites = () => {
        const { detail } = this.state

        if(!detail || !detail.activity || !detail.activity.siteNames || !detail.activity.siteNames.length) {
            return
        }

        return (
            <div className='result-item'>
                <div className='label'>适用门店</div>
                <div className='value word-ellipsis'>{detail.activity.siteNames.join(',')}</div>
            </div>
        )
    }

    doRenderResultView = () => {
        const { loading, detail } = this.state

        if(loading) {
            return (
                <div className='wrapper-loading'>
                    <ActivityIndicator text='信息加载中...'/>
                </div>
            )
        }

        if(!detail.record || !detail.activity) {
            return (
                <div className='wrapper-loading'>
                    <ActivityIndicator text='信息加载失败'/>
                </div>
            )
        }

        return (
            <div className='wrapper-result'>
                <div className='result-item'>
                    <div className='label'>剩余时间</div>
                    <div className='value word-ellipsis'>{CommonUtils.readableGameMinutes(detail.gameMinutes)}</div>
                </div>
                <div className='result-item'>
                    <div className='label'>账户余额</div>
                    <div className='value word-ellipsis'>￥{detail.balance}</div>
                </div>
                <div className='result-item'>
                    <div className='label'>优惠类型</div>
                    <div className='value word-ellipsis'>{Constants.DICT_COUPON_TYPE[detail.activity.couponType]}</div>
                </div>
                <div className='result-item'>
                    <div className='label'>设备类型</div>
                    <div className='value word-ellipsis'>{CommonUtils.resolveDictText(detail.activity.deviceType, this.state.deviceTypes, 'code', 'name')}</div>
                </div>
                <div className='result-item'>
                    <div className='label'>优惠券码</div>
                    <div className='value'>{detail.record.couponCode}</div>
                </div>
                {this.generateResultItemForSites()}
            </div>
        )
    }

    doRenderActionView = () => {
        const { detail } = this.state

        if(!detail || !detail.activity) {
            return (
                <div className="wrapper-action">
                    <button className="btn-back" onClick={this.handleBtnRefreshClick}>刷新</button>
                </div>
            )
        }
        
        return (
            <div className="wrapper-action">
                <button className="btn-back" onClick={this.handleBtnBackClick}>返回</button>
            </div>
        )
    }

    doRenderTipView = () => {
        const { detail } = this.state
        if(!detail || !detail.activity) {
            return
        }
        
        return (
            <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>
                优惠券兑换成功！请扫描设备屏幕上的二维码，开始体验游戏！
            </NoticeBar>
        )
    }

    render() {
        const { detail } = this.state

        return (
            <div className="page-user-coupon-result">
                {this.doRenderTipView()}
                <div className='wrapper-logo'>
                    <img src={iconLogo} alt=""/>
                </div>
                <div className='wrapper-title word-ellipsis'>{detail.activity?detail.activity.name:Constants.Strings.APP_NAME}</div>
                {this.doRenderResultView()}
                {this.doRenderActionView()}
            </div>
        )
    }
}

export default UserCouponResult;


// WEBPACK FOOTER //
// ./src/modules/UserCouponResult.js